import { render, staticRenderFns } from "./Tier.vue?vue&type=template&id=4f2502e6&lang=pug"
import script from "./Tier.vue?vue&type=script&lang=js"
export * from "./Tier.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports